import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import LoaderSpinner from 'shared/indicators/LoaderSpinner';

const ExportToExcelButton = ({ onExport, isLoading, disabled }) => (
    <Button
      onClick={onExport}
      disabled={disabled}
      className="k-button"
      icon={isLoading ? undefined : 'k-icon k-i-export'}
    >
      {isLoading && <LoaderSpinner sise="small" type="pulsing" style={{ color: 'black' }} />}
      Export
    </Button>
  );

export default ExportToExcelButton;
